import cookie from '@s-ui/js/lib/cookie'

import AuthenticationMappersFactory from '../../authentication/Mappers/factory.js'
import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import factoryLogger from '../../logger/index.js'
import TrackingValueObjectsFactory from '../../tracking/ValueObjects/factory.js'
import UserEntityFactory from '../Entities/factory.js'
import {UserErrorsFactory} from '../Errors/factory.js'
import {GenericUserError} from '../Errors/GenericUserError.js'
import {NotFoundUserError} from '../Errors/NotFoundUserError.js'
import {UnauthorizedUserError} from '../Errors/UnauthorizedUserError.js'
import UserMappersFactory from '../Mappers/factory.js'
import {FromHttpGetConsentsResponseToUserConsentsStatusUserValueObjectMapper} from '../Mappers/FromHttpGetConsentsResponseToUserConsentsStatusUserValueObjectMapper.js'
import {FromUserConsentsStatusUserValueObjectToHttpUpdateConsentsRequestBodyMapper} from '../Mappers/FromUserConsentsStatusUserValueObjectToHttpUpdateConsentsRequestBodyMapper.js'
import {UserRequestsFactory} from '../Requests/factory.js'
import UserValueObjectsFactory from '../ValueObjects/factory.js'
import CookieUserCochesRepository from './CookieUserCochesRepository.js'
import CookieUserMotosRepository from './CookieUserMotosRepository.js'
import {EmptyUserRepository} from './EmptyUserRepository.js'
import HTTPUserRepository from './HTTPUserRepository.js'
import {SessionStorageUserRepository} from './SessionStorageUserRepository.js'

export default class UserRepositoriesFactory {
  static cookieUserRepository = ({config, jsCookie = cookie}) => {
    const APP_NAME = config.get('APP_NAME')
    const APP_NAME_COCHES = config.get('APP_NAME_COCHES')
    const Repository = APP_NAME === APP_NAME_COCHES ? CookieUserCochesRepository : CookieUserMotosRepository

    return new Repository({
      config,
      userEntityFactory: UserEntityFactory.userEntity,
      jsCookie
    })
  }

  /**
   * @return {EmptyUserRepository}
   */
  static emptyUserRepository = () => new EmptyUserRepository()

  static httpUserRepository = ({config}) =>
    new HTTPUserRepository({
      adShareByEmailUserErrorFactory: UserErrorsFactory.adShareByEmailUserError,
      apiWebUrl: config.get('API_URL'),
      authenticationFetcher: FetcherFactory.httpAuthenticationFetcher({config}),
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      fetcher: FetcherFactory.httpFetcher({config}),
      fromSubscriptionsRawDataToSpecificSubscriptionsMapper:
        UserMappersFactory.fromSubscriptionsRawDataToSpecificSubscriptionsMapper({config}),
      fromUserConsentsStatusUserValueObjectToHttpUpdateConsentsRequestBodyMapper:
        FromUserConsentsStatusUserValueObjectToHttpUpdateConsentsRequestBodyMapper.create({config}),
      fromHttpGetConsentsResponseToUserConsentsStatusUserValueObjectMapper:
        FromHttpGetConsentsResponseToUserConsentsStatusUserValueObjectMapper.create(),
      fromUserRawDataToUserEntityMapper: UserMappersFactory.fromUserRawDataToUserEntityMapper({config}),
      genericUserError: GenericUserError,
      hTTPUserRepositoryToContactResponseValueObjectMapper:
        UserMappersFactory.hTTPUserRepositoryToContactResponseValueObjectMapper({config}),
      hTTPUserTakeOutListToUserTakeOutListValueObjectMapper:
        UserMappersFactory.hTTPUserTakeOutListToUserTakeOutListValueObjectMapper({config}),
      log: factoryLogger({prefix: 'HTTPUserRepository'}),
      leadHitTrackingValueObjectFactory: TrackingValueObjectsFactory.leadHitTrackingValueObject,
      leadHitUserErrorFactory: UserErrorsFactory.leadHitUserError,
      notFoundUserError: NotFoundUserError,
      saveAdShareByEmailHitUserErrorFactory: UserErrorsFactory.saveAdShareByEmailHitUserError,
      securedApiUrl: config.get('SECURED_API_URL'),
      userTakeoutLinkValueObjectFactory: UserValueObjectsFactory.userTakeoutLinkValueObjectFactory,
      checkGigyaUserExistsUserErrorFactory: UserErrorsFactory.checkGigyaUserExistsUserError,
      userExistsValueObjectFactory: UserValueObjectsFactory.userExistsValueObjectFactory,
      getConversationUserErrorFactory: UserErrorsFactory.getConversationUserError,
      fromRawDataToGetConversationEntityUserMapper: UserMappersFactory.fromRawDataToGetConversationEntityUserMapper({
        config
      }),
      phoneVerificationStatusVOFactory: UserValueObjectsFactory.phoneVerificationStatusUserValueObject,
      sendEmailToVerifyUserError: UserErrorsFactory.sendEmailToVerifyUserError,
      subscriptionsUserValueObjectFactory: UserValueObjectsFactory.subscriptionsUserValueObject,
      unauthorizedUserError: UnauthorizedUserError,
      updateCurrentUserRequestFactory: UserRequestsFactory.updateCurrentUserRequest,
      userEntityFactory: UserEntityFactory.userEntity,
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      validatePhoneVerificationCodeUserErrorFactory: UserErrorsFactory.validatePhoneVerificationCodeUserError,
      httpResponseToSessionAuthenticationMapper: AuthenticationMappersFactory.httpResponseToSessionAuthenticationMapper(
        {
          config
        }
      )
    })

  /**
   * @return {SessionStorageUserRepository}
   */
  static sessionStorageUserRepository = ({config}) => {
    return new SessionStorageUserRepository({
      config,
      contactTokenValueObjectFactory: UserValueObjectsFactory.contactTokenUserValueObjectFactory
    })
  }
}
